/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ListTitles } from 'src/app/services/constants';
import { SearchResultItem } from 'src/app/services/models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sp-search-results',
  templateUrl: './sp-search-results.component.html'
})
export class SpSearchResultsComponent {

  @Input() items: SearchResultItem[] = [];

  getDocTitle(item: SearchResultItem): string {
    if (!item.Title) {
      return '';
    }
    const tokens = item.Title.split('.')
    if (tokens.length === 1) return item.Title;
    return tokens.slice(0, -1).join('.');
  }

  isOpenInChannelVisble(item: SearchResultItem): boolean {
    return item.ItemId !== undefined || item.IsGuidance;
  }

  isItemTitleVisible(item: SearchResultItem): boolean {
    return item.ItemId !== undefined || !item.IsDocument
  }

  constructor(private sanitizer: DomSanitizer) {}

  openDoc(item: SearchResultItem) : void {
   //ned to add this field in rest api
   const LinkFilename = item.Filename;
   if (LinkFilename.includes('._X') || LinkFilename.includes('.url_') || LinkFilename.includes('.url')) {
     const url = (item.HTACustomHyperLink && item.HTACustomHyperLink.trim().length > 0) ? item.HTACustomHyperLink : item.Title;
     if (url && (url.includes('https://') || url.includes('http://'))) {
       window.open(url);
     }
     else {
       window.open(`http://${url}`);
     }
   }
   else {
     const url = item.Url ? item.Url + "?web=1" : item.DefaultEncodingURL + "?web=1";
     window.open(url);
   }
  }

  getHighlightedSummary(item: SearchResultItem) : SafeHtml {
    if (item && item.HitHighlightedSummary) {
      return this.sanitizer.bypassSecurityTrustHtml(item.HitHighlightedSummary);
    }
    return undefined;
  }



  openInChannel(item: SearchResultItem) : void {

    let url = "";
    const isGuidance = item.IsGuidance;
    console.log(item.IsGuidance)
    const channelName = item.ChannelAcronym;
    const siteUrl = environment.siteUrl;
    const itemId = item.ItemId;
    const path = item.OriginalPath;
    switch (channelName) {
      case "ESA": {
        url = isGuidance ? "/hta-es-advice?tab=guidance" : "/hta-es-advice/detail/" + itemId;
        window.open(url);
        break;
      }
      case "TP": {
        url = isGuidance ? "/tp-insights?tab=guidance" : "/tp-insights/material/" + itemId;
        window.open(url);
        break;
      }
      case "HSR": {
        url = isGuidance ? "/pr-submission-resource?tab=guidance" : `/pr-submission-resource/detail/${itemId}`;
        window.open(url);
        break;
      }
      case "AEM": {
        if (isGuidance) {
          if (path.toLowerCase().indexOf("aem summaries/") > -1) {
            url = '/aems?tab=summaries';
          }
          else {
            url = '/aems?tab=guidance';
          }
        }
        else {
          url = `/aems/detail/${itemId}`;
        }

        window.open(url);
        break;
      }
      case "EEPR": {
        url = isGuidance ? "/ext-expert-panel?tab=guidance" : "/ext-expert-panel/advice-requests/detail/" + itemId;
        window.open(url);
        break;
      }
      case "AERC": {
        url = "/access-catalog";
        window.open(url);
        break;
      }
      case "EEP": {
        url = isGuidance ? "/ext-expert-panel?tab=guidance" : "/ext-expert-panel/detail/" + itemId;
        window.open(url);
        break;
      }
      case "EduHTA": {
        if (isGuidance) {
          url = (path.toLowerCase().indexOf("training materials/") > -1) ? "/hta-education/events-and-trainings" : "/aems?tab=guidance"
        }
        else {
          url = "/hta-education/about";
        }

        window.open(url);
        break;
      }
      case "HST": {
        url = "/pr-timeline/" + itemId;
        window.open(url);
        break;
      }
      case "HMC": {
        url = isGuidance ? "/itc-he-deliverables?tab=guidance" : `/itc-he-deliverables/detail/${itemId}`;
        window.open(url);
        break;
      }
      case "MAAP": {
        url = isGuidance ? "/market-access-trial-analysis?tab=guidance" : "/market-access-trial-analysis/resource/" + itemId;
        window.open(url);
        break;
      }
      case "AC": {
        url = isGuidance ? "/communities" : `/communities/detail/${itemId}?tab=${item.AcCommunityTab}`;
        if (item.AcCountryId) {
          url += `&countryId=${item.AcCountryId}`;
        }
        window.open(url);
        break;
      }
      // this is a folder path// special condition is added to navigate to the folder
      case "HTAT": {
        if (itemId === undefined) {
          const _path = path.split(ListTitles.HTATrends)[1];
          url = "/hta-trends/htatrends/docs?folder=" + _path;
          window.open(url);
        }
        break;
      }
    
      /* start AccessHUb-3.15-Relese  */
      case "FAQ": {
        url = "/faqs";
        window.open(url);
        break;
      }
      case "MADB": {
        url = "/past-hta-decisions";
         if (itemId === undefined) {   
         if(path.toLowerCase().includes("dispform.aspx?id="))
         {
          url = "/past-hta-decisions/learnmore/"+ path.toLowerCase().split("?id=")[1];         
         }
        }       
        window.open(url);
        break;
      }
      case "MAET": {
        url = "/market-access-trial-analysis/resource/{0}?tab=load-data";
        window.open(url);
        break;
      }
      case "CR": {
      
        url = isGuidance ? "/contract-rights?tab=contracting%20guidance" : "/contract-rights/view-contract-rights-data/" + parseInt(item.OriginalPath.substring(item.OriginalPath.lastIndexOf('=') + 1));
        window.open(url);
        break;
      }
      case "AERC": {
        url = "/access-catalog";
        window.open(url);
        break;
      }
      case "HMCNMA": {
        url = "/itc-he-deliverables";
        window.open(url);
        break;
      }
      case "ACHTAFAQ": {
        url = "/ac-hta-faq/faqs";
        window.open(url);
        break;
      }
      /* end AccessHUb-3.15-Relese  */
      default: {
        //statements;
        break;
      }
    }
  }
}
